// extracted by mini-css-extract-plugin
export default {"button":"AiPhotoGenerationButtonRefresh__button--30EGf"};